<template>
    <vs-tabs :color="colorx" id="appointment-tabs" class="background-white" v-if="customerHistory">
        <vs-tab @click="colorx = 'primary'" label="Checkin">
            <div v-if="customerHistory.checkin && customerHistory.checkin.length">
            <div
                class="con-tab-ejemplo py-3 pl-4 pr-2 border-bottom-custom leading-tight"
                v-for="(item, index) in customerHistory.checkin"
                :key="index"
            >
                <p
                class="font-bold mb-6 text-primary"
                v-if="checkinShowYear[index]"
                >{{getYear(item.created_at)}}</p>
                <div class="flex align-center pt-1">
                <div class="pr-6">
                    <p class="font-bold text-2xl pt-0">{{getDayOfMonth(item.created_at)}}</p>
                    <p class="text-grey-custom pt-0">{{getMonth(item.created_at)}}</p>
                </div>
                <div>
                    <p class="pt-0">
                    <span class="text-grey-custom text-xs">{{getDayOfWeek(item.created_at)}}</span>
                    <span
                        class="text-xs ml-3 text-uppercase"
                        :class="[`text-${getStatusColor(item.status)}`]"
                    >{{item.status}}</span>
                    </p>
                    <div>
                    <p class="font-bold text-md pt-0">Check in</p>
                    </div>
                </div>
                <div
                    class="font-bold ml-auto text-base"
                    v-if="item.total_price"
                >${{item.total_price}}</div>
                <div class="font-bold ml-auto text-base" v-else>$0</div>
                </div>
            </div>
            </div>
            <div v-else class="con-tab-ejemplo p-6">No checkin history</div>
        </vs-tab>

        <vs-tab @click="colorx = 'primary'" label="Order" v-if="isFromPos">
            <div>
                Order
            </div>
        </vs-tab>

        <vs-tab @click="colorx = 'primary'" label="Invoice" v-else>
            <div v-if="invoiceByCustomerList && invoiceByCustomerList.length">
                <div class="con-tab-ejemplo py-3 pl-4 pr-2 border-bottom-custom leading-tight" v-for="(item, index) in invoiceByCustomerList" :key="index">
                    <p class="font-bold mb-6 text-primary" v-if="invoiceShowYear[index]">{{getYear(item.created_at)}}</p>
                    <div class="flex pt-1">
                        <div class="pr-6">
                            <p class="font-bold text-2xl pt-0">{{getDayOfMonth(item.created_at)}}</p>
                            <p class="text-grey-custom pt-0">{{getMonth(item.created_at)}}</p>
                        </div>
                        <div>
                            <p class="pt-0 pb-1">
                                <span class="text-grey-custom text-xs">{{getDayOfWeek(item.created_at)}}</span>
                                <!-- <span class="text-xs ml-3 text-uppercase" :class="[`text-${getStatusColor(item.status)}`]">{{item.status}}</span> -->
                            </p>
                            <div v-if="item.invoice_details && item.invoice_details.length">
                                <div v-for="(detail, i) in item.invoice_details" :key="i" class="pb-2">
                                    <p class="font-bold text-md pt-0 detail-name">{{detail.product_name}}</p>
                                    <p class="text-grey-custom text-xs pt-0">{{readableDuration(detail.duration)}} with <span v-if="detail.employee_name">{{detail.employee_name}}</span> <span v-else>no staff</span></p>
                                </div>
                            </div>
                            <div v-else class="pb-2">
                                <p class="text-md pt-0">No service</p>
                            </div>
                        </div>
                        <div class="ml-auto">
                            <div v-if="item.total_before_discount != item.total_after_discount" class="flex">
                                <div class="text-line-through ml-auto mr-2 text-grey-custom text-sm" style="transform: translateY(1px)" v-if="item.total_before_discount">${{item.total_before_discount}}</div>
                                <div class="text-line-through ml-auto mr-2 text-grey-custom text-sm" style="transform: translateY(1px)" v-else>$0</div>

                                <div class="font-bold ml-auto text-base" v-if="item.total_after_discount">${{item.total_after_discount}}</div>
                                <div class="font-bold ml-auto text-base" v-else>$0</div>
                            </div>
                            <div v-else>
                                <div class="font-bold ml-auto text-base" v-if="item.total_after_discount">${{item.total_after_discount}}</div>
                                <div class="font-bold ml-auto text-base" v-else>$0</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="con-tab-ejemplo p-6">No invoice</div>
        </vs-tab>

        <vs-tab @click="colorx = 'primary'" label="Appointment">
            <div v-if="customerHistory.appointment && customerHistory.appointment.length">
                <div
                class="con-tab-ejemplo py-3 pl-4 pr-2 border-bottom-custom leading-tight"
                v-for="(item, index) in customerHistory.appointment"
                :key="index"
                >
                <p
                    class="font-bold mb-6 text-primary"
                    v-if="showYear[index]"
                >{{getYear(item.start_time)}}</p>
                <div class="flex align-center pt-1">
                    <div class="pr-6">
                    <p class="font-bold text-2xl pt-0">{{getDayOfMonth(item.start_time)}}</p>
                    <p class="text-grey-custom pt-0">{{getMonth(item.start_time)}}</p>
                    </div>
                    <div>
                    <p class="pt-0">
                        <span class="text-grey-custom text-xs">{{getDayOfWeek(item.start_time)}}</span>
                        <span
                        class="text-xs ml-3 text-uppercase"
                        :class="[`text-${getStatusColor(item.status)}`]"
                        >{{item.status}}</span>
                        <template v-if="isJsonString(item.extra_data) && JSON.parse(item.extra_data) && JSON.parse(item.extra_data).no_show == 1">
                            <span class="mx-2"> - </span>
                            <span class="no-show-alert">
                                NO SHOW
                            </span>
                        </template>
                    </p>
                    <div v-if="item.service">
                        <p class="font-bold text-md pt-0">{{item.service.name}}</p>
                        <p
                        class="text-grey-custom text-xs mt-1 pt-0"
                        >{{readableDuration(item.service.duration)}} with {{getStaffName(item.employee_id)}}</p>
                    </div>
                    </div>
                    <div
                    class="font-bold ml-auto text-base"
                    v-if="item.service && item.service.price"
                    >${{item.service.price}}</div>
                    <div class="font-bold ml-auto text-base" v-else>$0</div>
                </div>
                </div>
            </div>
            <div v-else class="con-tab-ejemplo p-6">No appointment history</div>
        </vs-tab>
</vs-tabs>
</template>

<script>
import moment from 'moment';
export default {
    name: 'appointment-tabs',
    props: {
        customerId: {
            type: Number,
            default: -1
        },
        isFromPos: {
            type: Boolean,
            default: false
        }
    },
    data() {
        // let showYear = [];
        if(this.customerId && this.customerId != -1) {
            this.$store.dispatch('customer/GET_CUSTOMER_HISTORY', this.customerId).then(()=> {
                this.getShowYear();
            });
            this.$store.dispatch('invoiceList/GET_LIST_INVOICE_BY_CUSTOMER', {id: this.customerId, 'per-page': 100}).then(() => {
                this.getInvoiceShowYear();
            });
        }
        return {
            showYear: [],
            checkinShowYear: [],
            invoiceShowYear: [],
            colorx: 'primary'
        }
    },
    computed: {
        customerHistory() {
            return this.$store.getters["customer/history"];
        },
        invoiceByCustomerList() {
            return this.$store.getters['invoiceList/invoiceByCustomerList'];
        }
    },
    methods: {
        readableDuration(duration) {
            //duration from minutes
            let hours = Math.floor(duration / 60);
            let minutes = duration - hours * 60;
            if (!isNaN(parseInt(hours)) && !isNaN(parseInt(minutes))) {
                return hours + "h" + minutes + "m";
            }
            return duration;
        },
        getStatusColor(status) {
            if (status == null) {
              return "primary";
            }
            status = status.toLowerCase();
            if (status == "scheduled" || status == "completed") {
              return "success";
            } else if (status == "cancel" || status == "pending" || status == "canceled") {
              return "danger";
            } else {
              return "primary";
            }
        },
        getStaffName(staff_id) {
            if (staff_id) {
              if (this.$store.getters["staff/detail"](staff_id)[0] !== undefined)
                return this.$store.getters["staff/detail"](staff_id)[0].name;
            }
            return "no staff";
        },
        getShowYear() {
            this.showYear = [];
            // let curYear = moment(new Date()).format('YYYY');
            // let curYear = moment().format("YYYY");
            let curYear = 0;
            let prev_year = curYear;
            let arr_appointment = this.$store.getters["customer/history"].appointment;

            for (let i = 0; i < arr_appointment.length; i++) {
                let year = this.getYear(arr_appointment[i].start_time);
                if (year == curYear) {
                    this.showYear.push(false);
                } else if (year != prev_year) {
                    prev_year = year;
                    this.showYear.push(true);
                } else {
                    this.showYear.push(false);
                }
            }

            this.checkinShowYear = [];
            // curYear = moment().format("YYYY");
            curYear = 0;
            prev_year = curYear;
            let arr_checkin = this.$store.getters["customer/history"].checkin;

            for (let i = 0; i < arr_checkin.length; i++) {
                let year = this.getYear(arr_checkin[i].created_at);
                if (year == curYear) {
                    this.checkinShowYear.push(false);
                } else if (year != prev_year) {
                    prev_year = year;
                    this.checkinShowYear.push(true);
                } else {
                    this.checkinShowYear.push(false);
                }
            }
        },
        getInvoiceShowYear() {
            this.invoiceShowYear = [];
            // let curYear = moment().format("YYYY");
            let curYear = 0;
            let prev_year = curYear;
            let arr_invoice = this.$store.getters['invoiceList/invoiceByCustomerList'];

            for (let i = 0; i < arr_invoice.length; i++) {
                let year = this.getYear(arr_invoice[i].created_at);
                if (year == curYear) {
                    this.invoiceShowYear.push(false);
                } else if (year != prev_year) {
                    prev_year = year;
                    this.invoiceShowYear.push(true);
                } else {
                    this.invoiceShowYear.push(false);
                }
            }
        },
        getDayOfWeek(date) {
            return moment(date).format("ddd HH:mm");
        },
        getDayOfMonth(date) {
            return moment(date).format("DD");
        },
        getYear(date) {
            return moment(date).format("YYYY");
        },
        getMonth(date) {
            return moment(date).format("MMM");
        },
        isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }
    }
}
</script>

<style lang="scss">
    #appointment-tabs {
        .vs-tabs--li {
            z-index: 40001;
        }
        .line-vs-tabs {
            z-index: 40001;
        }
        .vs-tabs--content {
            z-index: 40000;
        }
        .detail-name {
            max-width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // max-width: 200px;
            // max-width: 90%;
        }
        .vs-tabs--li button.vs-tabs--btn {
            padding-left: 0;
            padding-right: 0;
            span {
                font-size: 12px !important;
            }
        }
        .no-show-alert {
            font-size: 0.75rem;
            // background: #FFF0FF;
            color: #6600CC;
        }
        @media (max-width: 768px) {
            .vs-tabs--li button.vs-tabs--btn {
                padding: 10px 7px;
            }
        }
    }
</style>